module.exports = __webpack_public_path__ + "6b2f73362fb028a7d6af32f87b8ebbba.MP3";